import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { useAuth } from "../../context/AuthContext";

/**
 * iter109 — Post-login "Have you seen the Trip Wall?" pulse.
 *
 * Once per logged-in user (tracked via localStorage), pop a friendly toast
 * highlighting the Trip Wall so users notice it. Self-dismissing after 6s
 * with a "View" CTA that takes them to /wall.
 *
 * Mount globally — gates render via the `user` object, so logged-out
 * visitors never see it. Dismissal key is per user_id so different
 * accounts on the same browser each see the toast once.
 */
const PROMPT_PREFIX = "cc_wall_prompt_v1_";

export default function WallLoginPrompt() {
  const { user } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (!user || !user.user_id) return;
    const key = PROMPT_PREFIX + user.user_id;
    try {
      if (localStorage.getItem(key)) return;
      localStorage.setItem(key, String(Date.now()));
    } catch { /* private mode — show it anyway */ }
    // Small delay so it doesn't fight with the welcome-message toast that
    // fires on login.
    const t = setTimeout(() => {
      toast.message("📸 New trips on the Wall", {
        description: "See real photos from fellow campers across the UK.",
        duration: 7000,
        action: {
          label: "View",
          onClick: () => navigate("/wall"),
        },
      });
    }, 1500);
    return () => clearTimeout(t);
  }, [user, navigate]);

  return null;
}
